import React from 'react';
import { Card } from 'primereact/card';

export default function DriversPage() {
  const drivers = [
    { id: 'DR-001', name: 'Sathish', status: 'On Duty' },
    { id: 'DR-002', name: 'Kiran', status: 'Off Duty' },
    { id: 'DR-003', name: 'Aisha', status: 'On Duty' }
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginTop: 0 }}>Drivers</h2>
      <Card className="cyber-card">
        {drivers.map(d => (
          <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <div><strong>{d.name}</strong> ({d.id})</div>
            <div style={{ opacity: 0.8 }}>{d.status}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}